// Describe all known feature flags here as string literals
export enum FEATURE_FLAGS {
  ECOMMERCE = 'ecommerce',
  EDUCATION = 'education',
}
